import React from 'react'
import styled from 'styled-components'

import AssistChip from 'components/Luxkit/Chips/AssistChip'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'

const WidthLimitedAssistChip = styled(AssistChip)`
  max-width: 100%;
  overflow: hidden;

  & > div {
    overflow: hidden;
  }
`

interface Props {
  startIcon: React.ReactElement
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
  canEdit: boolean
  /** If false, won't render anything in read-only mode */
  showInReadOnly: boolean
}

function TripEditChip({
  startIcon,
  onClick,
  canEdit,
  showInReadOnly,
  children,
}: React.PropsWithChildren<Props>) {
  if (!canEdit) {
    if (!showInReadOnly) {
      return null
    }
    return (
      <BodyTextBlock variant="medium" startIcon={startIcon}>
        {children}
      </BodyTextBlock>
    )
  }
  return (
    <WidthLimitedAssistChip
      variant="filled"
      size="small"
      startIcon={startIcon}
      onClick={onClick}
    >
      {children}
    </WidthLimitedAssistChip>
  )
}

export default TripEditChip
